import React from 'react';

class NavSeparator extends React.Component {
  render() {
    return <span className="divider d-none d-lg-block" ></span>;
  }
}


export default NavSeparator;